<template>
  <div>
    
    <div v-if = "actualBundleLoadedFlag">
      <div class="content content-boxed">
        
        <div v-if="dashboardFlags.evsensAdminFlag===false" class="col-xs-12">
 
          <div  class="bg-image img-rounded overflow-hidden push tesla-bg">
          </div>
        </div>

        <div  class="row">
          
          <div class="col-xs-12">
            <h1 class="h2 font-w300 push">{{ labelTopPage1[actualLanguage] }}</h1>
              <power-live-monitor v-if="actualBundle.bundleRights.realTimeMeasurementPanel"></power-live-monitor>
            <div v-else class="block block-rounded push">
              <div class="block-content">
                <div class=" form-group row">
                  <div  class="col-xs-12 align-center">
                    <h1 class="h4 font-w300 push">{{ realTimeMeasurementPanelNotAvailable[actualLanguage] }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>


        <div class="row">
          <div class="col-xs-12">
            <h1 class="h2 font-w300 push">{{ labelTopPage[actualLanguage] }}</h1>

            

            <div class="block block-rounded">
              <div class="block-header">
                <h2 class="block-title">{{ labelTopDatePicker[actualLanguage] }}</h2>
              </div>
              <div class="block-content">
                <range-picker @refresh="refreshData"></range-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <display-channel-list ></display-channel-list>
          </div>
        </div>

      </div>
    </div>



    <div v-else>
      <div class="col-xs-12 push-50">
      </div>
      <div class="col-xs-12 push-50">
      </div>
      <div class="col-xs-12 push-50">
      </div>
      <div class="col-xs-12 push-50">
      </div>
      <div class="col-xs-12 push-50">
              <spinner size="large"></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import RangePicker from '@/components/RangePicker'
import Spinner from '@/components/Spinner'
import Bundle from './bundle'
import PieChart from '@/components/PieChart'
import DisplayChannelList from './DisplayChannelList'
import PowerLiveMonitor from './SubComponents/PowerLiveMonitor'

import {mapState, mapGetters} from 'vuex'

export default {
  name: 'measurementsIndex',
  data() {
    return {
      numberOfRow: [ 1, 2, 3, 4, 5 ],
      selectedDevices: 0,
      loadingPort: true,
      localIp : '',
      actualBundleLoadedFlag:false,
      actualLanguage : "FR",
      labelTopPage1: {FR: 'Mesures temps réel', EN: 'Real time measurement'},
      realTimeMeasurementPanelNotAvailable: {FR: "Mesure temps réel non disponible. Pour activer cette option vous devez contacter support@evsens.ca.",
                                            EN: 'Real-time measurement not available. To activate this option you must contact support@evsens.ca.'},

      labelTopPage: {FR: 'Mesures', EN: 'Measurement'},
      labelTopDatePicker: {FR: 'Plage à observer', EN: 'Period selector'},
      labelTopModuleSelector: {FR: 'Sélection de module', EN: 'Module selector'},
      labelButtonRealTime: {FR: 'Moniteur temps réél', EN: 'Real time monitor'},
      labelGraphPeakCurrent: {FR: 'Courant maximum', EN: 'Max current'},
      labelGraphCost: {FR: 'Coût', EN: 'Cost'},
      labelGraphSaving: {FR: 'Économies', EN: 'Savings'},
      labelGraphConsumption: {FR: 'Consommation', EN: 'Consumption'},
      dataTableFlag : false,

      crunchedMaxCurrent: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

      crunchedCost: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

      crunchedCunsumption: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

    }
  },
  components: {
    RangePicker,
    Spinner,
    PieChart,
    Bundle,
    DisplayChannelList,
    PowerLiveMonitor
  },
  computed: {
    ...mapState('devicesStore',['devices', 'devicesPortData']),
    ...mapState('chargesStore',['startDate', 'endDate']),
    ...mapState('sessionStore', ['profileData','dashboardFlags','actualBundle']),
  },
  watch: {
    selectedDevices() {
      //this.getDeviceData()
    }
  },
  methods: {
    refreshData(dates) {
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate)
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate)
      //this.getDeviceData()
    },

    loadLiveMonitor() {
      var localUrl ='http://' + this.localIp + '/live';      
      window.open(localUrl, '_blank');
      
    },

    refreshPieChart(){
      this.crunchedMaxCurrent.labels = []
      this.crunchedMaxCurrent.datasets[0].data = []
      this.crunchedCost.labels = []
      this.crunchedCost.datasets[0].data = []
      this.crunchedCunsumption.labels = []
      this.crunchedCunsumption.datasets[0].data = []
      //console.log(this.devicesPortData.portsData)
      for(var i = 0; i < this.devicesPortData.portsData.length;i++){
        this.crunchedMaxCurrent.labels.push(this.devicesPortData.portsData[i].portName)
        this.crunchedMaxCurrent.datasets[0].data.push(this.devicesPortData.portsData[i].peakPower.toFixed(2))
        this.crunchedCost.labels.push(this.devicesPortData.portsData[i].portName)
        this.crunchedCost.datasets[0].data.push(this.devicesPortData.portsData[i].sumCost.toFixed(2))
        this.crunchedCunsumption.labels.push(this.devicesPortData.portsData[i].portName)
        this.crunchedCunsumption.datasets[0].data.push(this.devicesPortData.portsData[i].sumKwr.toFixed(2))
      }
    }

  },
  mounted() {
    //this.getDeviceData()
    //console.log("---Measurement_Index_Mounted---");

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Measurement Index Mounted-------');
    //console.log(this.profileData);
    //console.log('-------Actual bundle--------');
    //console.log(this.actualBundle);



    /*
    if(this.actualBundle.bundle_id != '!!NONE!!'){
      var requestData = {'postAction':'ReadBundleData','bundleId':this.actualBundle.bundle_id}
      this.$store.dispatch('sessionStore/postBundle', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              console.log('-Measurement Index:ActualBundleData Loaded-')
              console.log(response.data.BundleData)
              this.bundleTempo = response.data.BundleData
              this.$store.dispatch('sessionStore/setActualBundle', this.bundleTempo)
              this.actualBundleLoadedFlag=true
              console.log(this.actualBundleLoadedFlag)
              }
              else{
                window.alert("La lecture du groupe système a échouée. / System group read fail. (Measurement Index:Mount)" + this.actualBundle.bundle_id )
                document.location.reload()
                }
          })
    }
    */
    this.actualBundleLoadedFlag=true




    //this.refreshPieChart()

    //this.dataTableFlag = this.profileData.profileInfo.profile_type.endUserCode.includes('DatTbl')

    //-----------------------------------
    //EXEMPLE CANVAS
    //https://codesource.io/build-a-drawing-app-with-and-vuejs-html5-canvas/
    //-----------------------------------


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tesla-bg {
  background-image: url('../../assets/pylone.png');
  min-height: 155px;
}

#canvas {
    
    border: 3px solid black;
    height: 200px;
    width: 200px
}

  .h2 {
    font-size: 26px; /* Taille de police par défaut */
  }
  .h3 {
    font-size: 20px; /* Taille de police par défaut */
  }
  .h4 {
    font-size: 16px; /* Taille de police par défaut */
  }
  .h5 {
    font-size: 16px; /* Taille de police par défaut */
  }

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {

      .h2 {
          font-size: 20px; /* Taille de police réduite pour les petits écrans */
      }
      .h3 {
          font-size: 18px; /* Taille de police réduite pour les petits écrans */
      }
      .h4 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
      .h5 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
  }

</style>



// WEBPACK FOOTER //
// Index.vue?42ef1f4a